import type { IconName } from '@hotjar/hotsauce';

export const DEFAULT_LABEL_ICONS: { [key: string]: IconName } = {
  bug: 'bug_label',
  confusion: 'confusion_label',
  conversion: 'conversion_label',
  frustration: 'frustration_label',
  issue: 'ui_ux_issue_label',
  success: 'success_label',
};
